import React from "react";
import { Modal, Row, Col } from "antd";
import momentTZ from "moment-timezone";

import { statusMapText } from "../../Utils";

const RowForm = props => (
  <Row style={{ padding: "5px 10px" }}>{props.children}</Row>
);

const ModalDetailBooking = ({
  showModalDetail,
  toggleModalDetail,
  dataBooking,
}) => {
  let status = dataBooking.id
    ? statusMapText(
        dataBooking.BookingStatuses
          ? dataBooking.BookingStatuses[0].status_label
          : null,
        dataBooking.BookingStatuses
          ? dataBooking.BookingStatuses[0].status
          : null
      )
    : "";
  return dataBooking.id ? (
    <Modal
      title="Detail Booking"
      visible={showModalDetail}
      onOk={() => toggleModalDetail(false)}
      onCancel={() => toggleModalDetail(false)}
      width={700}>
      <p>Detail Booking Appraiser</p>
      <RowForm>
        <Col span={8}>No. Order</Col>
        <Col span={16}>: {dataBooking.id}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Salesman</Col>
        <Col span={16}>: {dataBooking.SalesProfile.name}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Salesman Phone</Col>
        <Col span={16}>: {dataBooking.SalesProfile.phone}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Salesman Whatsapp</Col>
        <Col span={16}>: {dataBooking.SalesProfile.whatsapp}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Cabang</Col>
        <Col span={16}>: {dataBooking.SalesProfile.branch}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Mobil Bekas</Col>
        <Col span={16}>: {dataBooking.carType}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Mobil Baru</Col>
        <Col span={16}>
          : {dataBooking.NewCar ? dataBooking.NewCar.carName : null}
        </Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Jadwal</Col>
        <Col span={16}>
          :{" "}
          {momentTZ(dataBooking.bookingTime)
            .tz("Asia/Jakarta")
            .format("dddd, D MMMM YYYY")}
        </Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Jam</Col>
        <Col span={16}>
          :{" "}
          {momentTZ(dataBooking.bookingTime)
            .tz("Asia/Jakarta")
            .format("HH : mm")}
        </Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Catatan</Col>
        <Col span={16}>: {dataBooking.notes}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Tempat</Col>
        <Col span={16}>: {dataBooking.location}</Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Appraiser</Col>
        <Col span={16}>
          : {dataBooking.Appraiser ? dataBooking.Appraiser.name : null}
        </Col>
      </RowForm>
      <RowForm>
        <Col span={8}>Status</Col>
        <Col span={16}>
          : {status}{" "}
          <p style={{ color: "red", display: "inline-block" }}>
            {dataBooking &&
              dataBooking.cancelReason &&
              ` - ${dataBooking.cancelReason}`}
          </p>
          {dataBooking && dataBooking.cancelReason == "Other" && (
            <p style={{ color: "red", marginTop: "-10px" }}>
              &nbsp;&nbsp;
              {dataBooking.cancelNotes}{" "}
            </p>
          )}
        </Col>
      </RowForm>
    </Modal>
  ) : null;
};

export default ModalDetailBooking;



// WEBPACK FOOTER //
// src/components/Dashboard/ModalBooking/ModalDetailBooking.js